<div class="app-main">
    <core-layout-error-not-found [hidden]="status != STATUS_NOT_FOUND"></core-layout-error-not-found>

    <core-helpers-box-loading [hidden]="status != STATUS_LOADING"></core-helpers-box-loading>

    <div *ngIf="status == STATUS_DONE" class="share-feedback-main">
        <header class="mc-header">
            <core-title-section-labels [text]="'FEEDBACK OVERVIEW'" [labels]="feedback.version.labels"></core-title-section-labels>
        </header>
        <div class="feedback-info">
        <div class="feedback-info-main">
          <core-helper-box-header-user-date [user]="feedback.share.owner" [date]="feedback.share.date_created" [posText]="'requested feedback'">
          </core-helper-box-header-user-date>
          <div class="share-send-message">
            <div [innerHTML]="feedback.share.message"></div>
          </div>
        </div>

        <core-helpers-box-loading [hidden]="feedback"></core-helpers-box-loading>
        <div class="selected version-selected" *ngIf="feedback">
            <div class="feedback-content">
                <plugin-share-feedback-core-version-files
                    [version]="feedback.version"
                    [canCreateNotes]="false"
                    [notesActionText]="'See Notes'"
                    [notesActionStyle]="'see-notes'"
                    [prefixUrl]="prefixUrl"
                ></plugin-share-feedback-core-version-files>
<!-- TODO: know who will be the user here -->
                <plugin-share-feedback-core-version-messages
                    [version]="feedback.version"
                    [user]="feedback.user"
                    [addMessage]="false"
                    [canCreateNotes]="false"
                    [notesActionText]="'See Notes'"
                    [notesActionStyle]="'see-notes'"
                    [prefixUrl]="prefixUrl"
                    [prefixNotesUrl]="prefixNotesUrl"
                ></plugin-share-feedback-core-version-messages>

                <!-- Others responses -->
                <div class="share-feedback-others-feedback" >
                    <!-- <h3>ALL APPROVAL RESPONSES</h3> -->
                    <plugin-share-feedback-core-version-approval-response-list
                        [version]="feedback.version" [prefixUrl]="prefixUrl"
                    ></plugin-share-feedback-core-version-approval-response-list>

                </div>
            </div>
        </div>
    </div>
</div>
